import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { CustomFile } from "src/app/models/custom-file-model";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class DefaultService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  active(
    endpoint: string,
    id: string,
    value: boolean,
    name_field?: string
  ): Observable<any> {
    let formData = new FormData();

    let values = {};
    if (name_field) {
      values[name_field] = value;
    } else {
      values = { active: value };
    }
    formData.append("data", JSON.stringify(values));

    return this.http.put(
      environment.api + "/" + endpoint + "/" + id,
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
        },
      }
    );
  }

  get_light_with_custom_filters(
    endpoint: string,
    filters: string
  ): Observable<any> {

    let profile = this.authService.currentUserValue.is_connect_with
      ? "&profile=" + this.authService.currentUserValue.profile.id
      : "";
    return this.http.get(
      environment.api + "/" + endpoint + "?" + filters + profile,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  get_light(
    endpoint: string,
    pageSize: number,
    page: number,
    show_pagination: boolean,
    filters?: string,
    second_filters?: string
  ): Observable<any> {
    
    let profile = this.authService.currentUserValue.is_connect_with
      ? "&profile=" + this.authService.currentUserValue.profile.id
      : "";

    let pagination = show_pagination
      ? "pagination[pageSize]=" +
        pageSize.toString() +
        "&pagination[page]=" +
        page.toString()
      : "";
    return this.http.get(
      environment.api +
        "/" +
        endpoint +
        "?" +
        pagination +
        (filters ? filters : "") +
        (second_filters ? second_filters : "") +
        profile,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  get(endpoint: string): Observable<any> {

    const hasQuestionMark = endpoint.includes("?");
    let profile = this.authService.currentUserValue?.is_connect_with
      ? (hasQuestionMark ? "&" : "?") +
        "profile=" +
        this.authService.currentUserValue?.profile?.id
      : "";
    return this.http.get(environment.api + "/" + endpoint + profile, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
        "Content-Type": "application/json",
      },
    });
  }

  get_one(endpoint: string, value: string) {
    let profile = this.authService.currentUserValue?.is_connect_with
      ? "&profile=" + this.authService.currentUserValue?.profile?.id
      : "";
    return this.http.get(
      environment.api + "/" + endpoint + "/" + value + "?populate=*" + profile,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  create(
    endpoint: string,
    values: any,
    custom_files: Array<CustomFile>
  ): Observable<any> {
    let profile = this.authService.currentUserValue.is_connect_with
      ? this.authService.currentUserValue.profile.id
      : null;

    values["profile"] = profile;

    let datas: any;
    if (custom_files.length > 0) {
      let formData = new FormData();
      custom_files.forEach((element: CustomFile) => {
        formData.append("files." + element.name, element.file);
      });
      formData.append("data", JSON.stringify(values));
      datas = formData;
    } else {
      datas = { data: values };
    }

    return this.http.post(
      environment.api + "/" + endpoint + "?populate=*",
      datas,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
        },
      }
    );
  }

  create_light(endpoint: string, values: any): Observable<any> {
    return this.http.post(environment.api + endpoint, values, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

  normal_update(endpoint: string, id: string, values: any): Observable<any> {
    return this.http.put(environment.api + "/" + endpoint + "/" + id, values, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

  update(
    endpoint: string,
    id: string,
    values: any,
    custom_files: Array<CustomFile>
  ): Observable<any> {
    let formData = new FormData();
    if (endpoint == "users") {
      formData.append("data", JSON.stringify(values));
    } else {
      if (custom_files.length > 0) {
        custom_files.forEach((element: CustomFile) => {
          formData.append("files." + element.name, element.file);
        });
        formData.append("data", JSON.stringify(values));
      } else {
        formData.append("data", JSON.stringify(values));
      }
    }

    return this.http.put(
      environment.api + "/" + endpoint + "/" + id,
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
        },
      }
    );
  }

  many_update(endpoint: string, values: any) {
    return this.http.post(
      environment.api + "/" + endpoint + "/manyUpdate",
      values,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
        },
      }
    );
  }

  delete(endpoint: string, id: string) {
    return this.http.delete(environment.api + "/" + endpoint + "/" + id, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

  post(route: string, body: any): Observable<any> {
    return this.http.post(environment.api + "/" + route, body, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

  public_get_with_full_route(route: string): Observable<any> {
    return this.http.get(environment.api + "/" + route, {});
  }

  generateRandomString(length: number): string {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
